export default {
  account: () => import("C:/BuildAgent/work/546b3c95a3861166/b2c/b2c-nuxt/layouts/account.vue").then(m => m.default || m),
  catalog: () => import("C:/BuildAgent/work/546b3c95a3861166/b2c/b2c-nuxt/layouts/catalog.vue").then(m => m.default || m),
  order: () => import("C:/BuildAgent/work/546b3c95a3861166/b2c/b2c-nuxt/layouts/order.vue").then(m => m.default || m)
}